import { render, staticRenderFns } from "./MeetingList.vue?vue&type=template&id=4429137a&scoped=true&"
import script from "./MeetingList.vue?vue&type=script&lang=js&"
export * from "./MeetingList.vue?vue&type=script&lang=js&"
import style0 from "./MeetingList.vue?vue&type=style&index=0&id=4429137a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4429137a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4429137a')) {
      api.createRecord('4429137a', component.options)
    } else {
      api.reload('4429137a', component.options)
    }
    module.hot.accept("./MeetingList.vue?vue&type=template&id=4429137a&scoped=true&", function () {
      api.rerender('4429137a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/meetings/MeetingList.vue"
export default component.exports